import { useEffect, useState } from 'react';

const ALL = 'ALL';

interface EnrollmentAndEnrolleeDetails {
    exchangeStartYear: number;
    currentCoverageYear: number;
}

const useGetEnrollmentYears = (enrollmentandenrolleedetails: EnrollmentAndEnrolleeDetails) => {
    const [years, setYears] = useState<string[]>([]);

    useEffect(() => {
        let yrs = [ALL];
        let year;
        for (
            year = enrollmentandenrolleedetails.currentCoverageYear;
            year >= enrollmentandenrolleedetails.exchangeStartYear;
            year--
        ) {
            yrs.push(year);
        }
        setYears(yrs);
    }, [enrollmentandenrolleedetails]);

    return years;
};

export default useGetEnrollmentYears;
